import { PennsylvaniaPIPDocument } from '../../../src/components'

export default function PennsylvaniaPIPDocumentUpload() {
  return (
    <div className="cure-inner-container">
      <PennsylvaniaPIPDocument />
    </div>
  )
}
